<template>
  <div class="contact" ref="page">
    <!-- 페이지 상단 헤더 섹션 -->
    <section class="page-header">
      <div class="overlay"></div>
      <div class="container relative z-10">
        <span class="badge-light">GET IN TOUCH</span>
        <h1 class="page-title">고객문의</h1>
        <p>아스톡의 전문가들이 귀하의 자산 가치를 높일 최적의 솔루션을 제안해 드립니다.</p>
      </div>
    </section>

    <!-- 메인 컨텐츠 섹션 (스크롤 애니메이션 적용) -->
    <section class="contact-main animated-section">
      <div class="container">
        <div class="flex-row">
          <!-- 왼쪽 정보 패널 -->
          <div class="contact-info-panel">
            <h2>Partner with <br/><span class="text-red">ASTOC</span></h2>
            <p class="description">
              단순한 용역 계약을 넘어, 신뢰할 수 있는 비즈니스 파트너로서
              투명하고 과학적인 건물 관리 서비스를 약속드립니다.
            </p>

            <!-- 상세 연락처 정보 -->
            <div class="info-details">
              <div class="detail-item">
                <div class="icon" aria-hidden="true">📍</div>
                <div class="text">
                  <h3>본사 위치</h3>
                  <p>경기도 고양시 덕양구 삼원로63(아크비즈)</p>
                </div>
              </div>
              <div class="detail-item">
                <div class="icon" aria-hidden="true">📞</div>
                <div class="text">
                  <h3>대표 번호</h3>
                  <p>1533-0231</p>
                </div>
              </div>
              <div class="detail-item">
                <div class="icon" aria-hidden="true">✉️</div>
                <div class="text">
                  <h3>이메일 문의</h3>
                  <p>pera65@naver.com</p>
                </div>
              </div>
              <div class="detail-item">
                <div class="icon" aria-hidden="true">⏰</div>
                <div class="text">
                  <h3>운영 시간</h3>
                  <p>평일 09:00 - 18:00 (현장 관제 24시간)</p>
                </div>
              </div>
            </div>


          </div>

          <!-- 오른쪽 문의 폼 패널 -->
          <div class="contact-form-panel">
            <div class="form-card">
              <!-- 폼 제출 후 결과 메시지를 표시하는 영역 -->
              <div v-if="submitStatus" class="submit-message" :class="submitStatus">
                <p v-if="submitStatus === 'success'">✅ 문의가 성공적으로 접수되었습니다. 곧 연락드리겠습니다.</p>
                <p v-if="submitStatus === 'error'">❌ 오류가 발생했습니다. 잠시 후 다시 시도해주세요.</p>
              </div>

              <h3>상담 신청</h3>
              <p>문의 내용을 남겨주시면 담당자가 24시간 이내에 연락드립니다.</p>

              <!-- 폼 제출 이벤트 핸들러 연결 -->
              <form @submit.prevent="handleSubmit">
                <div class="form-row">
                  <div class="form-group">
                    <label>성함 / 담당자명</label>
                    <input type="text" v-model="form.name" required placeholder="이름을 입력하세요">
                  </div>
                  <div></div>
                  <div class="form-group">
                    <label>기업명 / 단지명</label>
                    <input type="text" v-model="form.company" required placeholder="회사 또는 건물명">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>연락처</label>
                    <input type="tel" v-model="form.phone" required placeholder="010-0000-0000">
                  </div>
                  <div></div>
                  <div class="form-group">
                    <label>이메일</label>
                    <input type="email" v-model="form.email" required placeholder="example@email.com">
                  </div>
                </div>

                <div class="form-group">
                  <label>문의 유형</label>
                  <select v-model="form.type">
                    <option value="total">부동산 종합 관리 (PM+FM+행정)</option>
                    <option value="fm">시설 관리 (FM) 단독 위탁</option>
                    <option value="cleaning">위생/미화/아스톡 방역 서비스</option>
                    <option value="security">보안/경비 및 주차 관리</option>
                    <option value="consulting">기술 컨설팅 및 장기수선계획 수립</option>
                    <option value="it">ASTOC IT 솔루션 도입 문의</option>
                    <option value="pest">해충방제서비스 문의</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>상세 내용</label>
                  <textarea v-model="form.message" rows="6" placeholder="관리 면적, 설비 특이사항 등 상세 내용을 입력해주시면 더 정확한 상담이 가능합니다."></textarea>
                </div>

                <div class="privacy-check">
                  <input type="checkbox" id="privacy" v-model="form.privacy" required>
                  <label for="privacy">개인정보 수집 및 이용에 동의합니다.</label>
                </div>

                <button type="submit" class="btn btn-primary full-width" :disabled="isSubmitting">
                  <span v-if="isSubmitting">전송 중...</span>
                  <span v-else>문의하기</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 파트너사 로고 섹션 -->
    <!-- Global Network / Partners -->
    <section class="partners bg-light animated-section">
      <div class="container">
        <SectionHeader title="Trust Partners" subtitle="아스톡과 함께하는 주요 고객사 및 협력사" />
        <div class="partner-logos">
          <div class="logo-item">MAJOR CONSTRUCTION</div>
          <div class="logo-item">OFFICE BUILDINGS</div>
          <div class="logo-item">RESIDENTIAL COMPLEXES</div>
          <div class="logo-item">PUBLIC INSTITUTIONS</div>
          <div class="logo-item">RETAIL CENTERS</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// 공통 컴포넌트인 SectionHeader와 API 통신을 위한 axios를 가져옵니다.
import SectionHeader from '../components/SectionHeader.vue';
import apiClient from '@/api'; // 수정: 직접 axios 대신 api.js에서 가져옵니다.

export default {
  components: { SectionHeader },
  name: 'ContactView',
  // 컴포넌트의 데이터 상태를 정의합니다.
  data() {
    return {
      // 폼 입력 값을 저장하는 객체
      form: {
        name: '',
        company: '',
        phone: '',
        email: '',
        type: 'total',
        message: '',
        privacy: false
      },
      isSubmitting: false, // 폼 제출 진행 중 상태
      submitStatus: null, // 폼 제출 결과 상태 ('success' 또는 'error')
    }
  },
  methods: {
    // 폼 제출 시 호출되는 비동기 메서드
    async handleSubmit() {
      // 중복 제출 방지
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      this.submitStatus = null;

      try {
        // 백엔드 스키마에 맞게 필드명을 변환하여 전송할 데이터를 준비합니다.
        // 프론트엔드 폼의 'type', 'privacy' 필드를 백엔드가 기대하는 'inquiry_type', 'is_privacy_agreed'로 매핑합니다.
        const payload = {
          name: this.form.name,
          company: this.form.company,
          phone: this.form.phone,
          email: this.form.email,
          inquiry_type: this.form.type,
          message: this.form.message,
          is_privacy_agreed: this.form.privacy
        };
        // axios를 사용하여 백엔드 API('/api/contact')에 POST 요청을 보냅니다.
        // vue.config.js의 프록시 설정 덕분에 실제로는 'http://localhost:9090/api/contact'로 요청됩니다.
        await apiClient.post('/api/contact', payload); // 수정: apiClient를 사용하고, 개발/프로덕션 모두 동작하는 전체 경로를 사용합니다.

        // 제출 성공 시 상태를 'success'로 변경하고 폼을 초기화합니다.
        this.submitStatus = 'success';
        this.form = { name: '', company: '', phone: '', email: '', type: 'total', message: '', privacy: false };
      } catch (error) {
        // 오류 발생 시 콘솔에 에러를 기록하고 상태를 'error'로 변경합니다.
        console.error('문의 제출 오류:', error);
        this.submitStatus = 'error';
      } finally {
        // 성공/실패 여부와 관계없이 제출 상태를 false로 되돌립니다.
        this.isSubmitting = false;
        // 5초 후에 결과 메시지를 자동으로 숨깁니다.
        setTimeout(() => {
          this.submitStatus = null;
        }, 5000); // 5초 후 메시지 숨김
      }
    },
  },
  // 컴포넌트가 DOM에 마운트된 후 실행되는 라이프사이클 훅
  mounted() {
    // IntersectionObserver를 사용하여 스크롤 시 섹션이 나타나는 애니메이션 효과를 구현합니다.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    // 'animated-section' 클래스를 가진 모든 요소를 관찰 대상으로 등록합니다.
    this.$refs.page.querySelectorAll('.animated-section').forEach(section => {
      observer.observe(section);
    });
  }
}
</script>

<!-- 이 컴포넌트에만 적용되는 스타일 -->
<style scoped>
.page-header {
  position: relative;
  height: 350px;
  background: url('~@/assets/images/contact-header-bg.jpg') center/cover;
  display: flex;
  align-items: center;
  color: white;
  text-align: center;
}
.page-header .container {
  position: relative;
  z-index: 2;
}
.overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(217, 48, 37, 0.8);
}
.badge-light { background: rgba(255,255,255,0.1); color: white; padding: 8px 15px; border-radius: 20px; font-size: 13px; font-weight: 700; }
.page-title { font-size: 3rem; font-weight: 800; margin-top: 1rem; text-shadow: 0 2px 8px rgba(0,0,0,0.5); }
.page-header .container p { text-shadow: 0 1px 4px rgba(0,0,0,0.4); }

.contact-main { padding: 8rem 0; }
.flex-row { display: flex; gap: 6rem; align-items: flex-start; }

.contact-info-panel { flex: 0.8; }
.contact-info-panel h2 { font-size: 3rem; font-weight: 800; color: var(--primary-blue); margin-bottom: 1.5rem; line-height: 1.2; }
.text-red { color: var(--primary-red); }
.description { font-size: 1.1rem; color: var(--text-light); margin-bottom: 4rem; line-height: 1.8; }

.info-details { display: flex; flex-direction: column; gap: 2.5rem; }
.detail-item { display: flex; gap: 1.5rem; }
.detail-item .icon { font-size: 1.8rem; background: var(--bg-gray); width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
.detail-item h3 { font-size: 1.1rem; margin-bottom: 0.3rem; color: var(--text-dark); }
.detail-item p { color: var(--text-light); }

.download-box { margin-top: 5rem; padding: 2rem; background: var(--bg-light); border-radius: 8px; }
.btn-link { color: var(--primary-red); font-weight: 700; text-decoration: none; border-bottom: 2px solid var(--primary-red); }

.contact-form-panel { flex: 1.2; }
.form-card { background: white; padding: 4rem; border-radius: 20px; box-shadow: 0 30px 60px rgba(0,0,0,0.1); border-top: 5px solid var(--primary-red); }
.form-card h3 { font-size: 2rem; margin-bottom: 1rem; color: var(--primary-blue); }
.form-card p { color: var(--text-light); margin-bottom: 3rem; }

.submit-message { padding: 1rem; margin-bottom: 2rem; border-radius: 8px; text-align: center; font-weight: 600; }
.submit-message.success { background-color: #e6f4ea; color: #34a853; }
.submit-message.error { background-color: #fce8e6; color: #d93025; }

.form-row { display: flex; gap: 1.5rem; margin-bottom: 1.5rem; }
.form-group { flex: 1; }
.form-group label { display: block; font-size: 0.9rem; font-weight: 700; color: var(--text-dark); margin-bottom: 0.8rem; }
input, select, textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: #fcfcfc;
  font-family: inherit;
}
input:focus, select:focus, textarea:focus { outline: none; border-color: var(--primary-red); box-shadow: 0 0 0 4px rgba(217, 48, 37, 0.1); }

.privacy-check { display: flex; align-items: center; gap: 10px; margin: 2rem 0; font-size: 0.9rem; color: var(--text-light); }
.privacy-check input { width: auto; }

.btn.full-width { width: 100%; padding: 1.2rem; font-size: 1.1rem; }
.btn:disabled { background: #ccc; cursor: not-allowed; }

.partners { padding: 6rem 0; }
.partner-logos {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 25px;
  margin-top: 4rem;
}
.logo-item {
  padding: 2.5rem 1.5rem;
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.05);
  text-align: center;
  transition: all 0.3s ease;
  border-top: 5px solid var(--primary-red);
  color: var(--primary-blue);
  font-weight: 900;
  font-size: 15px;
}
.logo-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.08);
}

@media (max-width: 1024px) {
  .flex-row { flex-direction: column; }
  .form-card { padding: 2rem; }
}
@media (max-width: 768px) {
  .form-row { flex-direction: column; gap: 0; }
  .partner-logos {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
}
</style>